const RadioCardAccordion = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $initial = $scope.find('.radio-card-accordion-controller:checked');

        if ($initial.length) {
            $initial.closest('.accordion').find('.collapse').collapse('show');
        }

        $scope.on('change', '.radio-card-accordion.accordion .radio-card-accordion-controller', function() {
            const $this = $(this);

            const $accordion = $this.closest('.accordion');
            const $others = $('.radio-card-accordion.accordion').not($accordion);

            $others.find('.collapse').collapse('hide');
            $accordion.find('.collapse').collapse('show');
        });
    },
};

export default RadioCardAccordion;
